import {BaseContainerModel} from '../base-container.model';
import {app_password_policy_line_RowClass} from '../../dbschema';

export class PasswordPolicyContainerModel extends BaseContainerModel {
  app_password_policy_line: app_password_policy_line_RowClass = new app_password_policy_line_RowClass();
}
